import { NumberFormat } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import { getCurrentLocale } from '../../../../../../utils/getCurrentLocale'
import { BillsTableRow } from '../../types/billsTableRow'
import { isBillsTableFieldSuggestion } from '../../utils/isBillsTableFieldSuggestion'
import { BillsTableNoDataField } from '../BillsTableNoDataField'
import { BillsTableSuggestedField } from '../BillsTableSuggestedField'

interface BillsTableAmountCellProps {
  row: BillsTableRow
}

export const BillsTableAmountCell = ({ row }: BillsTableAmountCellProps): ReactElement => {
  const locale = getCurrentLocale()
  const currency = row.currency.actual ?? row.currency.suggestion

  // Sanity check for TS, it's expected to always have a currency when dealing with amounts
  if (!currency) {
    return <BillsTableNoDataField />
  }

  if (isBillsTableFieldSuggestion(row.amountTotal)) {
    return (
      <BillsTableSuggestedField value={NumberFormat.getCurrencyNumber(row.amountTotal.suggestion, currency, locale)} />
    )
  }

  if (row.amountTotal.actual === null) {
    return <BillsTableNoDataField />
  }

  return <Typography.Text>{NumberFormat.getCurrencyNumber(row.amountTotal.actual, currency, locale)}</Typography.Text>
}
